export default {
  breakpoints: {
    mobile: 320,
    tablet: 576,
    desktop: 768,
  },
}
